import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import LspivService from '../../services/LspivService';

const initialState = {
    jobs: [],
    currentJobId: null,
    currentJob: null,
    isLoading: false,
    error: null,
};

export const fetchJobs = createAsyncThunk('lspiv/fetchJobs', async () => {
    return await LspivService.listJobs();
});

export const createJob = createAsyncThunk('lspiv/createJob', async () => {
    return await LspivService.createJob();
});

export const fetchJob = createAsyncThunk('lspiv/fetchJob', async (jobId) => {
    return await LspivService.getJob(jobId);
});

export const removeJob = createAsyncThunk('lspiv/removeJob', async (jobId) => {
    await LspivService.deleteJob(jobId);
    return jobId;
});

const lspivSlice = createSlice({
    name: 'lspiv',
    initialState,
    reducers: {
        setCurrentJobId(state, action) {
            state.currentJobId = action.payload;
        },
        clearCurrentJob(state) {
            state.currentJobId = null;
            state.currentJob = null;
        },
    },
    extraReducers: (b) => {
        b
            .addCase(fetchJobs.pending, (s) => { s.isLoading = true; s.error = null; })
            .addCase(fetchJobs.fulfilled, (s, a) => { s.isLoading = false; s.jobs = a.payload; })
            .addCase(fetchJobs.rejected, (s, a) => { s.isLoading = false; s.error = a.error?.message; })
            .addCase(createJob.fulfilled, (s, a) => { s.currentJobId = a.payload.job_id; })
            .addCase(fetchJob.pending, (s) => { s.isLoading = true; })
            .addCase(fetchJob.fulfilled, (s, a) => { s.isLoading = false; s.currentJob = a.payload; })
            .addCase(fetchJob.rejected, (s, a) => { s.isLoading = false; s.error = a.error?.message; })
            .addCase(removeJob.fulfilled, (s, a) => { s.jobs = s.jobs.filter((j) => j.id !== a.payload); });
    },
});

export const { setCurrentJobId, clearCurrentJob } = lspivSlice.actions;
export default lspivSlice.reducer;
